module.exports = __webpack_public_path__ + "img/sephotaSet1.06f4e5d6.jpg";